/** @jsx h */
import { h } from 'preact'

const SvgComponent = () => (
  <svg width={10} height={13} class='Organization-locationMedia'>
    <path
      d='M1.03 9.484V8c.357.093 1.236.138 1.607.138.864 0 1.654-.245 2.419-.483.783-.243 1.523-.473 2.338-.473.6 0 1.187.127 1.82.396l.032.011.088.025c.043.01.094.016.145.016.259 0 .435-.121.458-.311l.003-.01-.001-6.303a.574.574 0 0 0-.293-.512A5.46 5.46 0 0 0 7.397 0C6.418 0 5.543.272 4.77.513 4.045.737 3.36.95 2.64.95c-.376 0-1.254-.059-1.61-.178V.528L.894.497a.741.741 0 0 0-.173-.02.73.73 0 0 0-.395.104.555.555 0 0 0-.22.286c-.018.049-.03.099-.042.149l-.005.043v10.897c0 .047.009.13.018.178.018.103.047.259.147.396a.58.58 0 0 0 .304.217c.049.013.096.02.142.02a.378.378 0 0 0 .298-.131.266.266 0 0 0 .06-.16V9.486z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
)

export default SvgComponent
